import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObservableService {

  constructor() { }
  public loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public error: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public success: BehaviorSubject<string> = new BehaviorSubject<string>('');

  loadingChanged(loading: boolean) {
    this.loading.next(loading);
  }

  errorChanged(error: string) {
    this.error.next(error);
  }

  successChanged(message: string) {
    this.success.next(message);
  }

}